import axios from '@axios'
import { storePagination } from '@/mixins/store'
import { sorting } from '@/mixins'

const getInitialState = () => ({
  ...storePagination.state(),
  checkingAccounts: [],
  filters: { storeId: null, name: '', active: 'true' },
})

export default {
  namespaced: true,

  state: getInitialState(),

  mutations: {
    ...storePagination.mutations,

    SET_CHECKING_ACCOUNTS(state, checkingAccounts) {
      state.checkingAccounts = checkingAccounts
    },
    SET_FILTERS(state, filters) {
      state.filters = filters
    },

    CLEAN_STATE(state) {
      const { checkingAccounts } = getInitialState()
      state.checkingAccounts = checkingAccounts
    },
  },

  actions: {
    ...storePagination.actions,

    async fetchCheckingAccounts({ commit, state }) {
      const { data } = await axios.get('/api/financial/checking-accounts', {
        params: {
          ...state.filters,
          pageSize: state.paging.pageSize,
          pageIndex: state.paging.currentPage - 1,
          sortBy: sorting.methods.getSorting(state),
        },
      })

      commit('SET_CHECKING_ACCOUNTS', data.results || [])
      commit('SET_PAGING', {
        ...state.paging,
        rowCount: data.rowCount || 0,
        rowsInCurrentPage: data.rowsInCurrentPage || 0,
      })
    },

    resetFilters({ commit }) {
      commit('SET_CURRENT_PAGE', 1)
      commit('SET_FILTERS', getInitialState().filters)
    },

    cleanState({ commit }) {
      commit('CLEAN_STATE')
    },
  },
}
